const cognitoConfig = {
  userPoolId: import.meta.env.VITE_USER_POOL_ID,
  userPoolClientId: import.meta.env.VITE_APP_CLIENT_ID,
  userPoolRegion: import.meta.env.VITE_REGION,
  domain: import.meta.env.VITE_COGNITO_DOMAIN
} as const;

/**
 * Google / Apple via Cognito Hosted UI. Requires AWS IdPs + OAuth app client settings
 * (see docs/SOCIAL_LOGIN_AWS_SETUP.md). Set VITE_SOCIAL_LOGIN_ENABLED=true when ready.
 */
export const SOCIAL_LOGIN_ENABLED = import.meta.env.VITE_SOCIAL_LOGIN_ENABLED === 'true';

export default cognitoConfig;
